<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="待装箱明细"
      width="1200px"
      top="8vh"
      class="packMarkDetailUnRecord">
    <el-table
        class="tableBox"
        :data="filterRecordVOS"
        border
        stripe
        height="60vh"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"/>
      <!--      <el-table-column prop="barcode" align="left" label="追溯码">-->
      <!--        <template slot="header" slot-scope="scope">-->
      <!--          <el-input-->
      <!--              v-model="scope.row.barcode"-->
      <!--              @input="handleSearch"-->
      <!--              placeholder="搜索追溯码"/>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column prop="barcode" label="追溯码">
        <template slot="header">
          <input
              v-model.trim="search"
              type="text"
              style="width: 100%;"
              placeholder="搜索追溯码"
              @keyup.enter="handleSearch()">
        </template>
      </el-table-column>
      <el-table-column prop="billNo" align="left" label="订单编号" width="140"/>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" :disabled="selection.length===0" type="primary"
                 @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "PackMarkDetailUnRecord",
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      submitLoading: false,
      contentLoading: false,
      recordVOS: [],
      filterRecordVOS: [],
      selection: [],
      search: "",
    };
  },
  methods: {
    open(id) {
      this.dialogVisible = true;
      this.getData(id);
    },
    handleSearch() {
      this.selection = [];
      if (!this.search) {
        this.filterRecordVOS = [...this.recordVOS];
        return;
      }
      this.filterRecordVOS = this.recordVOS.filter(row => {
        return row.barcode.includes(this.search);
      });
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },

    getData(id) {
      this.contentLoading = true;
      this.$http
          .get("basic", `packMarks/listUnPack/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.recordVOS = resp.data;
              this.filterRecordVOS = this.recordVOS;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
    },

    // 编辑、新建
    handleSubmit() {
      if (this.selection.length > 0) {
        this.dialogVisible = false;
        this.$emit("select", this.selection);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.packMarkDetailUnRecord .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.packMarkDetailUnRecord .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.packMarkDetailUnRecord .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.packMarkDetailUnRecord .el-divider--horizontal {
  margin: 10px 0;
}

.packMarkDetailUnRecord .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.tableBox .el-form-item__content {
  margin-left: 0 !important;
}

.tableBox .el-form-item {
  margin-bottom: 0;
}

.tableBox .el-input--mini .el-input__inner {
  text-align: center;
}
</style>
